import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CdekCourierEstimatedTimeIntervalDto } from './CdekCourierEstimatedTimeIntervalDto'
/**
* Class CdekCourierEstimatedDateIntervalsDto
*  Окна доставки на одну календарную дату.
*/
export class CdekCourierEstimatedDateIntervalsDto extends ActiveModel {

/**
  * date
  * Дата доставки.
  */
  @ActiveField('')
  date: string = ''


/**
  * @property intervals
  * Временные интервалы (`HH:mm`, как в ответе СДЭК).  */
  @ActiveField({
    factory: [CdekCourierEstimatedTimeIntervalDto, () => []]
  })
  intervals: Array<CdekCourierEstimatedTimeIntervalDto> = []
}
